import { usePersonCheckInApi } from "../api/PersonCheckInApiClient";
import { PersonCheckInFrontendService } from "../services/PersonCheckInFrontendService";

export const usePersonCheckInService = (): PersonCheckInFrontendService =>
  new PersonCheckInFrontendService(usePersonCheckInApi());
